export var PopupType = /*#__PURE__*/ function(PopupType) {
    PopupType["BalloonToolbar"] = "BALLOON_TOOLBAR";
    PopupType["LinkForm"] = "LINK_FORM";
    PopupType["TaskForm"] = "TASK_FORM";
    return PopupType;
}({});
export var TabNames = /*#__PURE__*/ function(TabNames) {
    TabNames["CommentsTab"] = "comments";
    TabNames["ConversationsTab"] = "conversations";
    TabNames["Tasks"] = "tasks";
    return TabNames;
}({});
export var EditorModes = /*#__PURE__*/ function(EditorModes) {
    EditorModes["Public"] = "PUBLIC";
    EditorModes["Private"] = "PRIVATE";
    return EditorModes;
}({});
export var ResourceSectionType = /*#__PURE__*/ function(ResourceSectionType) {
    ResourceSectionType["Milestone"] = "MILESTONE";
    ResourceSectionType["Task"] = "TASK";
    ResourceSectionType["Approval"] = "APPROVAL";
    ResourceSectionType["DocumentTask"] = "DOCUMENT";
    ResourceSectionType["Summary"] = "SUMMARY";
    return ResourceSectionType;
}({});
export var DocumentResourceType = /*#__PURE__*/ function(DocumentResourceType) {
    DocumentResourceType["Default"] = "DEFAULT";
    DocumentResourceType["Highlight"] = "HIGHLIGHT";
    DocumentResourceType["Custom"] = "CUSTOM";
    return DocumentResourceType;
}({});
